import { render, staticRenderFns } from "./HotelsInfoPanelReplace.vue?vue&type=template&id=f6a8d700&"
import script from "./HotelsInfoPanelReplace.vue?vue&type=script&lang=js&"
export * from "./HotelsInfoPanelReplace.vue?vue&type=script&lang=js&"
import style0 from "./HotelsInfoPanelReplace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports